module.exports = require('./lib/wix-run-mode');
